import React, { createContext, useCallback, useState } from "react";
import { Alert, Col, Row } from "react-bootstrap";
import { Info } from "react-feather";

import ShipmentItems from "./ShipmentItems";
import Shipments from "./Shipments";
import StickySidebar from "./StickySidebar";

import { deepClone } from "../../../../utils/helper";

import shipmentService from "../../../../services/shipmentService";

const ShipmentsContext = createContext();

const ShipmentAccount = ({ submitting, setSubmitting, selectedAccount }) => {
  const [shipments, setShipments] = useState([]);
  const [shipmentCartons, setShipmentCartons] = useState();
  const [shipmentItems, setShipmentItems] = useState();

  const [selectedShipment, setSelectedShipment] = useState();
  const [selectedShipmentItems, setSelectedShipmentItems] = useState([]);

  const handleScroll = useCallback((elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  const getShipments = async ({
    shipmentId,
    sellingPartnerId,
    amazonShipmentId,
    shipTo,
    units,
    amazonShipmentStatus,
    shipToCity,
    shipToState,
    shipmentStatusId,
    shipmentCategoryId,
    isShipmentPlan,
    createdAtStart,
    createdAtEnd,
    globalSearch,
    pageIndex,
    pageSize,
    sortBy,
  }) => {
    const result = await shipmentService.getShipments({
      shipmentId,
      sellingPartnerId,
      amazonShipmentId,
      shipTo,
      units,
      amazonShipmentStatus,
      shipToCity,
      shipToState,
      shipmentStatusId,
      shipmentCategoryId,
      isShipmentPlan,
      createdAtStart,
      createdAtEnd,
      globalSearch,
      pageIndex,
      pageSize,
      sortBy,
    });

    return result;
  };

  const getShipmentCartons = async (shipment) => {
    const response = await shipmentService.getShipmentCartons({
      shipmentId: shipment.shipmentId,
    });

    if (response.success) {
      setShipmentCartons(response.shipmentCartons);
    } else {
      console.log(response);
    }
  };

  const getShipmentItems = async (shipment) => {
    const response = await shipmentService.getShipmentItems({
      shipmentId: shipment.shipmentId,
    });

    if (response.success) {
      shipment.totalItems = response.shipmentItems.length;

      const reducedShipmentItems = response.shipmentItems.reduce(
        (result, item) => {
          //Clone the item first to preserve the shipment items.
          const clonedItem = deepClone(item);

          //Find an existing shipment.
          const existingShipmentItemIndex = result.findIndex(
            (item) =>
              item.fnsku.toUpperCase() === clonedItem.fnsku.toUpperCase()
          );

          if (existingShipmentItemIndex !== -1) {
            //If an existing item is found, update the quantity and add item to array.
            result[existingShipmentItemIndex].quantity++;
            result[existingShipmentItemIndex].originalShipmentItems.push(
              clonedItem
            );
          } else {
            result.push({
              shipmentId: clonedItem.shipmentId,
              sku: clonedItem.sku,
              asin: clonedItem.asin,
              fnsku: clonedItem.fnsku,
              imageUrl: clonedItem.imageUrl,
              quantity: 1,
              originalShipmentItems: [clonedItem],
            });
          }

          return result;
        },
        []
      );

      setShipmentItems(reducedShipmentItems);
      setSelectedShipment(shipment);
    } else {
      console.log(response);
    }
  };

  return (
    <ShipmentsContext.Provider
      value={{
        submitting,
        setSubmitting,
        selectedAccount,
        shipments,
        setShipments,
        selectedShipment,
        setSelectedShipment,
        shipmentCartons,
        setShipmentCartons,
        shipmentItems,
        setShipmentItems,
        selectedShipmentItems,
        setSelectedShipmentItems,
        handleScroll,
        getShipments,
        getShipmentItems,
        getShipmentCartons,
      }}
    >
      {shipments || !shipments ? (
        <Row>
          <Col
            className="sticky-top"
            xl={{ span: 4, order: "last" }}
            style={{ top: 20 }}
          >
            <StickySidebar />
          </Col>
          <Col xl={8}>
            <Shipments key={selectedAccount.sellingPartnerId} />

            {selectedShipment && shipmentItems?.length > 0 ? (
              <div id="shipment-items">
                <ShipmentItems />
              </div>
            ) : shipmentItems && !shipmentItems.length > 0 ? (
              <Alert variant="warning">
                <div className="alert-icon">
                  <Info
                    className="position-relative top-50 start-50 translate-middle"
                    size={20}
                  />
                </div>
                <div className="alert-message">
                  There doesn't seem to be any items in shipment{" "}
                  <strong>{selectedShipment?.amazonShipmentId}</strong>. Try
                  selecting a different shipment.
                </div>
              </Alert>
            ) : null}
          </Col>
        </Row>
      ) : (
        shipments?.length > 0 && (
          <Row>
            <Col xxl={8}>
              <Alert variant="warning">
                <div className="alert-icon">
                  <Info
                    className="position-relative top-50 start-50 translate-middle"
                    size={20}
                  />
                </div>
                <div className="alert-message">
                  There doesn't seem to be any shipments for{" "}
                  <strong>{selectedAccount.listingAccount}</strong>. Try
                  selecting a different account to view current shipments.
                </div>
              </Alert>
            </Col>
          </Row>
        )
      )}
    </ShipmentsContext.Provider>
  );
};

export { ShipmentsContext };

export default ShipmentAccount;
